import { Component, OnInit } from '@angular/core';
import { NavigationBarComponent } from '../../components/navigation-bar/navigation-bar.component';
import { NavigationTabsComponent } from '../../components/navigation-tabs/navigation-tabs.component';
import { NgIf } from '@angular/common';
import { NavigationBarBackComponent } from '../../components/navigation-bar-back/navigation-bar-back.component';
import { DashboardLayoutService } from './dashboard-layout.service';
import { PortalDataElementListIndicatorComponent } from '../../components/portal-data-element-list-indicator/portal-data-element-list-indicator.component';
import { PortalDataDashboardGlobalIndicatorBarComponent } from '../../components/portal-data-dashboard-global-indicator-bar/portal-data-dashboard-global-indicator-bar.component';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [
    NavigationBarComponent,
    NavigationBarBackComponent,
    NavigationTabsComponent,
    NgIf,
    PortalDataElementListIndicatorComponent,
    PortalDataDashboardGlobalIndicatorBarComponent,
  ],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
})
export class DashboardLayoutComponent implements OnInit {
  isNavigationBarDisplayed = true;
  isNavigationBarBackDisplayed = false;
  isNavigationTabsDisplayed = true;
  isPortalDataIndicatorDisplayed = true;
  isPortalDataDashboardGlobalIndicatorDisplayed = true;
  previousUrl?: string;

  constructor(private dashboardLayoutService: DashboardLayoutService) {}

  ngOnInit() {
    this.dashboardLayoutService.isNavigationBarDisplayed$.subscribe(
      isNavigationBarDisplayed => {
        this.isNavigationBarDisplayed = isNavigationBarDisplayed;
      }
    );

    this.dashboardLayoutService.isNavigationBarBackDisplayed$.subscribe(
      isNavigationBarBackDisplayed => {
        this.isNavigationBarBackDisplayed = isNavigationBarBackDisplayed;
      }
    );

    this.dashboardLayoutService.isNavigationTabsDisplayed$.subscribe(
      isNavigationTabsDisplayed => {
        this.isNavigationTabsDisplayed = isNavigationTabsDisplayed;
      }
    );

    this.dashboardLayoutService.isPortalDataIndicatorDisplayed$.subscribe(
      isPortalDataIndicatorDisplayed => {
        this.isPortalDataIndicatorDisplayed = isPortalDataIndicatorDisplayed;
      }
    );

    this.dashboardLayoutService.isPortalDataDashboardGlobalIndicatorDisplayed$.subscribe(
      isPortalDataDashboardGlobalIndicatorDisplayed => {
        this.isPortalDataDashboardGlobalIndicatorDisplayed =
          isPortalDataDashboardGlobalIndicatorDisplayed;
      }
    );

    this.dashboardLayoutService.previousPageUrl$.subscribe(previousUrl => {
      this.previousUrl = previousUrl;
    });
  }
}
